import { render } from "./MyShipPricingLog.vue?vue&type=template&id=46b2efe5&ts=true"
import script from "./MyShipPricingLog.vue?vue&type=script&lang=ts"
export * from "./MyShipPricingLog.vue?vue&type=script&lang=ts"

import "./MyShipPricingLog.vue?vue&type=style&index=0&id=46b2efe5&lang=css"

import exportComponent from "/var/www/vhosts/jahajibd.com/ia.jahajibd.com/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__